import { render, staticRenderFns } from "./NotificationsDetailed.vue?vue&type=template&id=24bb9c1d&"
import script from "./NotificationsDetailed.vue?vue&type=script&lang=js&"
export * from "./NotificationsDetailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports